import { useEffect } from 'react';
import { useAuthStore } from '../stores/auth-store';
import { initializeNotificationsListener, cleanupNotificationsListener } from '../lib/realtime/notifications-listener';
import { initializeDeviceListener, cleanupDeviceListener } from '../lib/realtime/device-listener';

export function useRealtime() {
  const { user, isAuthenticated } = useAuthStore();

  useEffect(() => {
    if (!isAuthenticated || !user) {
      return;
    }

    initializeNotificationsListener(user.id);
    initializeDeviceListener(user.id);

    return () => {
      cleanupNotificationsListener();
      cleanupDeviceListener();
    };
  }, [isAuthenticated, user]);
}
